<template>
  <div>
      <div v-if="loading" class="text-center my-4">
          <b-spinner></b-spinner>
      </div>
      <div v-else>
          <div class="d-flex">
              <b-avatar badge :badge-variant="agent.status == 1 ? 'success': 'danger'" :src="agent.displayPicture"></b-avatar>
          <div class="my-auto ml-3">
                <h4 class="m-0 p-0">{{agent.userName}}</h4>
                <p class="text-muted m-0 p-0">{{agent.role}}</p>
                <p class="m-0 p-0">
                    {{agent.email || agent.userName + '@on-track.in'}}
                </p>
                <p v-if="agent.status == 1" class="text-success">
                    Your Account status is Active and Running.
                </p>
                <p v-else class="text-warning">
                    Your Account is deactivated, please contact tech team.
                </p>
                <p>Profile created on {{agent.createdAt | moment('ll')}}</p>
                <b-row cols-md="12">
                    <b-col md="3">
                        <p>
                        <i class="fal fa-birthday-cake"></i> {{agent.dob | moment('ll')}}
                        </p>
                    </b-col>
                    <b-col md="3">
                        <p>
                            <i class="fal fa-building"></i> {{agent.doj | moment('ll')}}
                        </p>
                    </b-col>
                    <b-col md="6">
                        <p>
                            <i class="fal fa-envelope"></i> {{agent.email}}
                        </p>
                    </b-col>
                    <b-col md="3">
                        <p>
                            <i class="fal fa-phone"></i> {{agent.mobile}}
                        </p>
                    </b-col>
                </b-row>
          </div>
          </div>
      </div>
  </div>
</template>

<script>
import {HTTP2} from '../../../axios/http-common'
export default {
    data() {
        return {
            loading: false,
            agent: []
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        async loadData() {
            this.loading = true
            try {
            const {data} = await HTTP2.get('/get/agent?id='+ Number(localStorage.getItem('agent_id')))
            this.agent = data
        }catch(err){
            console.log(err)
        } finally {
            this.loading = false
        }
        }
    }
}
</script>

<style>

</style>